import { render, staticRenderFns } from "./VendorProvider.vue?vue&type=template&id=ff3c58ae&lang=pug&"
import script from "./VendorProvider.vue?vue&type=script&lang=js&"
export * from "./VendorProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports